import React from "react";
import { motion } from "framer-motion";
import { Flame, ArrowRight } from "lucide-react";

export const Scarcity = ({ onCTA, onScheduleClick }) => {
  return (
    <section
      data-testid="scarcity-section"
      className="relative py-24 sm:py-32 border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-0 grid-pattern opacity-40" />
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-[#D4AF37]/10 blur-[160px] rounded-full pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-6 sm:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="inline-flex items-center gap-2 glass-gold rounded-full px-4 py-1.5 mb-8"
        >
          <Flame className="w-3.5 h-3.5 text-[#D4AF37]" />
          <span className="text-[11px] tracking-[0.2em] uppercase text-[#D4AF37] font-medium">
            Limited Slots
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.05 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light text-white"
        >
          Limited project slots <br />
          <span className="gold-text italic">available this month.</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-6 text-[#B0B0B0] max-w-2xl mx-auto text-lg"
        >
          To maintain quality and provide personal attention, only a limited number of
          projects are accepted each month. Reserve your spot before it's gone.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-10"
        >
          <button
            data-testid="scarcity-cta"
            onClick={onCTA}
            className="btn-gold-glow inline-flex items-center gap-2 bg-[#D4AF37] hover:bg-[#E6C35C] text-black font-semibold rounded-full px-8 py-4 transition-all shadow-[0_0_30px_rgba(212,175,55,0.35)] hover:shadow-[0_0_50px_rgba(230,195,92,0.55)]"
          >
            Book Your Free Consultation
            <ArrowRight className="w-4 h-4" />
          </button>
          {onScheduleClick && (
            <button
              data-testid="scarcity-calendly"
              onClick={onScheduleClick}
              className="inline-flex items-center gap-2 bg-transparent text-white border border-[#D4AF37]/40 hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 rounded-full px-7 py-4 transition-all ml-3"
            >
              Or pick a time
            </button>
          )}
        </motion.div>
      </div>
    </section>
  );
};
